import React, { Component } from 'react';
import TermsView from 'views/TermsView';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class TermsContainer extends Component {
  render() {
    return <TermsView />;
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
      },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TermsContainer);



// WEBPACK FOOTER //
// ./src/containers/TermsContainer.js